import React from 'react';
import { Link } from 'react-router-dom';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Translation } from 'react-i18next';

import headerBackground from '../Images/header-background.png';
import Footer from '../components/Footer';
import progressBar from '../Images/progressBar.png';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: theme.spacing(7),
  },
  buttonLogin: {
    fontWeight: 'bold',
    color: '#F9F9F9',
    backgroundColor: '#009E49',
    margin: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    paddingTop: theme.spacing(1.1),
    paddingBottom: theme.spacing(1.1),
    fontSize: 18,
  },
  buttonRegister: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ED1B24',
    fontWeight: 'bold',
    color: '#ED1B24',
    backgroundColor: '#ffffff',
    margin: theme.spacing(1),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    fontSize: 18,
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  description: {
    marginTop: theme.spacing(10),
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#E1E1E1',
  },
  eVisaText: {
    marginTop: theme.spacing(1) - 35,
    display: 'flex',
    justifyContent: 'center',
    width: 90,
    backgroundColor: '#ffffff',
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
    color: '#B3B3B3',
    fontSize: 30,
  },
  infoText: {
    margin: theme.spacing(2),
    fontSize: 17,
  },
  progressBarContainer: {
    marginTop: theme.spacing(1) * 15,
  },
  barProgressItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  barProgressStyle: {
    marginTop: theme.spacing(1) * 2.5,
    marginLeft: theme.spacing(1) - 22,
    marginRight: theme.spacing(1) - 50,
  },
  barProgressStyle2: {
    marginTop: theme.spacing(1) * 2.5,
    marginLeft: theme.spacing(1) - 50,
    marginRight: theme.spacing(1) - 42,
  },
  barProgressStyle3: {
    marginTop: theme.spacing(1) * 2.5,
    marginLeft: theme.spacing(1) - 42,
    marginRight: theme.spacing(1) - 14,
  },
  barProgressNumber: {
    marginBottom: theme.spacing(1) * 2,
    borderStyle: 'solid',
    borderWidth: 3,
    borderColor: '#D7ECE1',
    borderRadius: 40,
    width: 50,
    height: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 25,
    fontWeight: '900',
    color: '#D7ECE1',
  },
  barProgressText: {
    fontWeight: '500',
    color: '#444343',
    minWidth: 116,
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#6fbf73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#D7ECE1',
      dark: '#FFCDD2',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

var sectionStyle = {
  height: '345px',
  backgroundImage: `url(${headerBackground})`,
};

const LandingPage = ({ classes }) => (
  <Translation>
    {(t) => {
      return (
        <div className={classes.root}>
          <Grid
            container
            alignItems="center"
            direction="row"
            justifyContent="center"
          >
            <Grid
              className={classes.headerContainer}
              style={sectionStyle}
              item
              xs={12}
            >
              <Typography
                style={{ color: '#ffffff', fontWeight: 'bold' }}
                variant="h3"
                align="center"
                gutterBottom
              >
                {t('onlineServices')}
              </Typography>
            </Grid>
            <Grid item xs={9} className={classes.description}>
              <Typography
                variant="h6"
                align="left"
                gutterBottom
                className={classes.eVisaText}
              >
                {t('eVisa')}
              </Typography>
              <Typography
                className={classes.infoText}
                variant="body1"
                align="left"
                gutterBottom
              >
                {t('info')}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Grid
                className={classes.buttonsContainer}
                container
                spacing={2}
                justifyContent="center"
              >
                <Grid>
                  <MuiThemeProvider theme={theme}>
                    <Button
                      variant="contained"
                      color="primary"
                      component={Link}
                      to="/login"
                      className={classes.buttonLogin}
                    >
                      {t('login')}
                    </Button>
                  </MuiThemeProvider>
                </Grid>
                <Grid>
                  <MuiThemeProvider theme={theme}>
                    <Button
                      variant="contained"
                      color="secondary"
                      component={Link}
                      to="/signup"
                      className={classes.buttonRegister}
                    >
                      {t('register')}
                    </Button>
                  </MuiThemeProvider>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid className={classes.progressBarContainer} item xs={12}>
            <Grid container justifyContent="center" direction="row">
              <Grid className={classes.barProgressItem}>
                <div className={classes.barProgressNumber}>1</div>
                <Typography
                  className={classes.barProgressText}
                  variant="subtitle1"
                >
                  {t('application')}
                </Typography>
              </Grid>
              <img
                className={classes.barProgressStyle}
                src={progressBar}
                width="15%"
                height="100%"
                alt="progress"
              />
              <Grid className={classes.barProgressItem}>
                <div className={classes.barProgressNumber}>2</div>
                <Typography
                  className={classes.barProgressText}
                  variant="subtitle1"
                >
                  {t('submitDocs')}
                </Typography>
              </Grid>
              <img
                className={classes.barProgressStyle2}
                src={progressBar}
                width="15%"
                height="100%"
                alt="progress"
              />
              <Grid className={classes.barProgressItem}>
                <div className={classes.barProgressNumber}>3</div>
                <Typography
                  className={classes.barProgressText}
                  variant="subtitle1"
                >
                  {t('privacyPayment')}
                </Typography>
              </Grid>
              <img
                className={classes.barProgressStyle3}
                src={progressBar}
                width="15%"
                height="100%"
                alt="progress"
              />
              <Grid className={classes.barProgressItem}>
                <div className={classes.barProgressNumber}>4</div>
                <Typography
                  className={classes.barProgressText}
                  variant="subtitle1"
                >
                  {t('approval')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Footer />
        </div>
      );
    }}
  </Translation>
);

export default withStyles(styles)(LandingPage);



// WEBPACK FOOTER //
// ./src/view/scenes/LandingPage/index.js